// sections/GeneralSettingsSection.jsx
import { useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faGears, faSave } from '@fortawesome/free-solid-svg-icons';
import { Button } from '@quyva/shared-ui';
import { useSettingsContext } from '../../../context';

export const GeneralSettings = ({
    SettingSections,
    generalSettingsRef,
    historyCounts,
    setHistoryCounts,
    runWithSaving,
    saveGeneralSection,
    isGeneralDirty,
}) => {
    
    const { loadGeneralSection } = useSettingsContext();

    useEffect(() => {
        loadGeneralSection?.();
    }, []);

    return (
        <div className='mb-6'>
            <div
                ref={generalSettingsRef}
                className='flex items-center justify-between font-semibold mb-6 py-3 px-4 text-texts-secondary300 uppercase bg-backgrounds-primary100 truncate'
            >
                <div className='flex items-center'>
                    <FontAwesomeIcon icon={faGears} className='mr-2' />
                    <div className='font-semibold text-texts-secondary300 uppercase truncate'>
                        {SettingSections.GENERAL}
                    </div>
                </div>

                <Button
                    type='success'
                    icon={faSave}
                    text='Save'
                    disabled={!isGeneralDirty}
                    onClick={() =>
                        runWithSaving(async () => {
                            await saveGeneralSection();
                        })
                    }
                />
            </div>

            <div className='h-[calc(100vh-210px)] w-full overflow-auto px-6 relative'>
                <div className='flex items-center mb-6'>
                    <div className='w-1/4 font-semibold text-texts-secondary300'>
                        <label htmlFor='historyCounts'>Chat History counts</label>
                    </div>
                    <div className='w-full md:w-1/4'>
                        <input
                            id='historyCounts'
                            type='number'
                            className='block w-auto md:w-30 p-2 mt-1 rounded-xl shadow-sm focus:ring-backgrounds-primary500 focus:border-backgrounds-primary400 hover:outline-none focus:outline-backgrounds-primary200 border hover:border-backgrounds-primary300'
                            value={historyCounts}
                            onChange={(e) => {
                                let value = e.target.value;
                                if (!/^\d*$/.test(value)) return;
                                let numValue = Number(value);
                                if (numValue >= 5 && numValue <= 10) {
                                    setHistoryCounts(numValue);
                                }
                            }}
                            onInput={(e) => {
                                if (e.target.value < 0) e.target.value = 0;
                                if (e.target.value > 10) e.target.value = 10;
                            }}
                            min='0'
                            max='10'
                            step='1'
                            pattern='[0-9]*'
                            inputMode='numeric'
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};